import React from 'react';
import { Link} from 'react-router-dom';
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import DatePicker from 'react-datepicker';
import Tooltip from 'rc-tooltip';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import 'react-datepicker/dist/react-datepicker.css';
import Joi from 'joi';
import Form from '../../common/form.jsx';
import withRouter from "../../common/withRouter.jsx";
import http from '../../services/httpService';
import auth from '../../services/authservice';
import {saveSupervisor,getSupervisor} from './../../services/supervisors';
import {getCompanys} from './../../services/companies';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { connect } from 'react-redux';
import { getCurrentUser, loadCurrentUser } from '../../store/users';

const Handle = Slider.Handle;
const apiUrl = process.env.REACT_APP_API_URL;


class Supervisor extends Form {
	constructor(props) {
		super(props);
	
		this.state = {
			countries: [],
			companies: [],
			//selectedCompany: '', // Local state for company selection, not sent to backend
			data: {
				username: '',
				password: '',
				email: '',
				firstName: '',
				lastName: '',
				initials: '',
				prefix: '',
				gender: '',
				dateBirth: new Date(),
				address1: '',
				address2: '',
				address3: '',
				zip: '',
				city: '',
				state: '',				
				country: '',
				//	longitude: null, latitude: null,   
				phone: '',
				mobile: '',
				skype: '',
				status: 'active',
			},
			imageSrc: null,
			errors: {}
		}

		this.prefixOptions = [
			{ value: 'mr', label: 'Mr.' },
			{ value: 'mrs', label: 'Mrs.' },
			{ value: 'mss', label: 'Mss.' },
			{ value: 'ms', label: 'Ms.' },
			{ value: 'prof', label: 'Prof.' },
			{ value: 'dr', label: 'Dr.' }
		];

		this.genderOptions = [
			{  value: 'female', label: 'Female' },
			{  value: 'male', label: 'Male' },
			{  value: 'transgender', label: 'Transgender' }
		];

		this.statusOptions = [
			{value: 'active', label: 'Active'},
			{value: 'banned', label: 'Banned'},
			{value: 'deleted', label: 'Deleted'},
			{value: 'inactive', label: 'Inactive'},
			{value: 'archived', label: 'Archived'}
		];
		
		this.handleSlider = (props) => {
			const { value, dragging, index, ...restProps } = props;
			return (
				<Tooltip
					prefixCls="rc-slider-tooltip"
					overlay={value}
					visible={dragging}
					placement="top"
					key={index}
				>
					<Handle value={value} {...restProps} />
				</Tooltip>
			);
		}
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onChangeImgHandler = this.onChangeImgHandler.bind(this);
	}


	async populateCountries() {
		const { data: countries } = await http.get(apiUrl+"/countries");
		this.setState({ countries: countries });
		this.selectCountries = this.state.countries.map((country) => ({ _id: country._id,label: country.name, value: country.name }));
	}

	// async populateCompanies() {
	// 	const { data: companies } = await getCompanys();
	// 	this.setState({ companies: companies });
	// 	this.selectCompanies = this.state.companies.map((company) => ({ _id: company._id, label: company.companyInfo?.businessName || company.companies?.username, value: company._id }));
	// }
	
	async populateGenders(){
		this.genderoptions = this.genderOptions.map(option => (
			<option key={option.label} value={option.value}>
				{option.value}
			</option>
		));
	}
	async populatePrefix(){
    this.prefixoptions = this.prefixOptions.map(option => (
		<option key={option.label} value={option.value}>
			{option.value}
		</option>
	));
	}

	async populateStatus(){
		this.statusoptions = this.statusOptions.map(option => (
			<option key={option.label} value={option.value}>
				{option.value}
			</option>
		));
	}

	async populateUser() { 
		try {
		  const userId = this.props.params?.id;
		
		  if (userId === "new" || !userId) return;

		  // Get the specific supervisor data using the individual endpoint
		  const { data: supervisorData } = await getSupervisor(userId);
		  
		  if (!supervisorData) {
			throw new Error("Supervisor not found");
		  }
		  
		  const mappedData = this.mapToViewModel(supervisorData);
		  
		  this.setState({ data: mappedData });
		  
		//   // Set selected company for UI display only (not sent to backend)
		//   if (supervisorData.companies && supervisorData.companies.length > 0) {
		// 	  this.setState({ selectedCompany: supervisorData.companies[0] });
		//   }
		} catch (ex) {
		  if (ex.response && ex.response.status === 404) {
			this.props.navigate ? this.props.navigate("/error") : this.props.history?.replace("/error");
		  } else {
			toast.error(`Error loading supervisor data: ${ex.message || 'Unknown error'}`);
		  }
		}
	  }


	async componentDidMount() {
		// Load current user for company role detection
		const user = auth.getProfile();
		if (user) {
			await this.props.loadCurrentUser(user._id);
		}
		
		await this.populatePrefix();
		await this.populateGenders();
		await this.populateStatus();
		await this.populateCountries();
		//await this.populateCompanies();
		await this.populateUser();
//		await this.getCurrentLocation();
	}

	// getCurrentLocation = () => {
	// 	if (navigator.geolocation) {
	// 		navigator.geolocation.getCurrentPosition(
	// 			(position) => {
	// 				const data = { ...this.state.data };
	// 				data.latitude = position.coords.latitude;
	// 				data.longitude = position.coords.longitude;
					
	// 				this.setState({ data });
	// 			},
	// 			(error) => {
	// 				// Set default coordinates (example: New York City)
	// 				const data = { ...this.state.data };
	// 				data.latitude = 40.7128;
	// 				data.longitude = -74.0060;
					
	// 				this.setState({ data });
					
	// 				// Show user-friendly error message
	// 				const errors = { ...this.state.errors };
	// 				switch(error.code) {
	// 					case error.PERMISSION_DENIED:
	// 						errors.location = "Location access denied. Using default coordinates.";
	// 						break;
	// 					case error.POSITION_UNAVAILABLE:
	// 						errors.location = "Location information unavailable. Using default coordinates.";
	// 						break;
	// 					case error.TIMEOUT:
	// 						errors.location = "Location request timed out. Using default coordinates.";
	// 						break;
	// 					default:
	// 						errors.location = "An unknown error occurred while retrieving location.";
	// 						break;
	// 				}
	// 				this.setState({ errors });
	// 			},
	// 			{
	// 				enableHighAccuracy: true,
	// 				timeout: 10000, // 10 seconds
	// 				maximumAge: 300000 // 5 minutes
	// 			}
	// 		);
	// 	} else {
	// 		// Set default coordinates
	// 		const data = { ...this.state.data };
	// 		data.latitude = 40.7128;
	// 		data.longitude = -74.0060;  
			
	// 		this.setState({ data });
			
	// 		const errors = { ...this.state.errors };
	// 		errors.location = "Geolocation not supported. Using default coordinates.";
	// 		this.setState({ errors });
	// 	}
	// };  

	schema = Joi.object({
		username: Joi.string().alphanum().min(1).max(30).required(),
		password: Joi.string().pattern(new RegExp('^[a-zA-Z0-9]{3,30}$')).optional().allow(''),
		email: Joi.string().email({ tlds: { allow: false } }).optional().allow(''),
		firstName: Joi.string().required(),
		lastName: Joi.string().required(),
		initials: Joi.any().optional().allow(''),
		gender: Joi.string().optional().allow(''),
		dateBirth: Joi.date().optional(),
		prefix: Joi.string().optional().allow(''),
		address1: Joi.any().optional().allow(''),
		address2: Joi.any().optional().allow(''),
		address3: Joi.any().optional().allow(''),
		zip: Joi.any().optional().allow(''),
		city: Joi.any().optional().allow(''),
		state: Joi.any().optional().allow(''),
		country: Joi.string().optional().allow(''),
		/*		longitude: Joi.number().optional().allow(null),
		latitude: Joi.number().optional().allow(null),    */
		phone: Joi.any().optional().allow(''),
		mobile: Joi.any().optional().allow(''),
		skype: Joi.any().optional().allow(''),
		status: Joi.string().required(),
		imageSrc: Joi.any().optional().allow('') // Add imageSrc validation
	});


	handleDobChange = (e) => {
		const errors = { ...this.state.errors };
		const obj = { ['dateBirth']: e };

		const data = { ...this.state.data };
		data['dateBirth'] = e;
		this.setState({ data });
	};
	
	onChangeImgHandler=event=>{
		this.setState({ imageSrc: event.target.files[0] });
	}


	// handleCompanyChange = (e) => {
	// 	const selectedCompany = e.target.value;
	// 	this.setState({ selectedCompany });
		
	// 	// Note: companies field is not sent to backend as it's not allowed
	// 	// This is just for UI display purposes
	// };

	doSubmit = async (user) => {
		if (!process.env.REACT_APP_API_URL) {
			toast.error("Configuration error: API URL not set");
			return;
		}
		
		const operationType = this.isEditing() ? "updating" : "creating";
		
		try{
			const submitData = { ...this.state.data };
			
			// Get current user and add businessNo if role is Company
			const currentUser = this.props.currentUser;
			
			// Check if role name is "Company"
			const isCompanyRole = (currentUser?.roleName === "Company") || 
								 (currentUser?.role === "Company") ||
								 (currentUser?.role?.name === "Company");
			
			if (currentUser && isCompanyRole) {
				// accountNo is already the ID string, not an object with _id
				submitData.businessNo = currentUser?.accountNo;
			}
			
			// Don't send empty password on update
			if (this.isEditing() && (!submitData.password || submitData.password.trim() === '')) {
				delete submitData.password;
			}
			
			const result = await saveSupervisor(submitData, this.state.imageSrc);
			
			toast.success(`Supervisor ${operationType === "updating" ? "updated" : "created"} successfully!`);
			
			// Navigate back to supervisors list
			setTimeout(() => {
				if (this.props.navigate) {
					this.props.navigate("/user/supervisors");
				} else if (this.props.history) {
					this.props.history.push("/user/supervisors");
				}
			}, 1500);
		}catch(ex){
			console.error('Submit error:', ex);
			console.error('Error response:', ex.response);
			console.error('Error response data:', ex.response?.data);
			console.error('Error response status:', ex.response?.status);
			
			let userMessage = "";
			
			if (ex.code === 'ECONNABORTED') {
				userMessage = "Request timed out. Please try again.";
			} else if (!ex.response) {
				userMessage = "Cannot connect to server. Please check your internet connection.";
			} else if (ex.response?.status >= 500) {
				userMessage = `Server error (${ex.response.status}). Please try again later.`;
			} else if (ex.response?.status >= 400) {
				userMessage = ex.response?.data?.message || ex.response?.data || 'Validation error occurred.';
			} else {
				userMessage = `Unexpected error: ${ex.message}`;
			}
			
			toast.error(userMessage);
			
			if(ex.response && ex.response.status < 500){
				const errors = {...this.state.errors};
				let errorMessage = ex.response.data;
				let path = 'general';
				
				if (typeof errorMessage === 'string' && errorMessage.includes('"')) {
					path = errorMessage.split('"')[1] || 'general';
				} else if (typeof errorMessage === 'object' && errorMessage.message) {
					errorMessage = errorMessage.message;
				}
				
				errors[path] = errorMessage;
				this.setState({errors});
			}
		}
	};
	
	mapToViewModel(supervisorData) {
		// Handle both array and object responses
		const supervisorRecord = Array.isArray(supervisorData) ? supervisorData[0] : supervisorData;
		
		if (!supervisorRecord) {
			// Return default empty data if no supervisor found
			return {
				username: '',
				password: '',
				email: '',
				firstName: '',
				lastName: '',
				initials: '',
				gender: '',
				dateBirth: new Date(),
				prefix: '',
				address1: '',
				address2: '',
				address3: '',
				zip: '',
				city: '',
				state: '',
				country: '',
	//			longitude: null, latitude: null,
				phone: '',
				mobile: '',
				skype: '',
				status: 'active',
				imageSrc: ''
			};
		}
		
		// Extract data from the nested structure (based on supervisorsTable structure)
		// supervisorsTable shows data comes from 'companies' property
		const supervisor = supervisorRecord.companies || supervisorRecord.supervisors || supervisorRecord;
		const companyInfo = supervisorRecord.companyInfo || {};

		// Handle contactName fields - check if nested or flat
		let firstName = '', lastName = '', initials = '';
		if (supervisor.contactName && typeof supervisor.contactName === 'object') {
			firstName = supervisor.contactName.first || '';
			lastName = supervisor.contactName.last || '';
			initials = supervisor.contactName.initials || '';
		} else {
			firstName = supervisor.firstName || '';
			lastName = supervisor.lastName || '';
			initials = supervisor.initials || '';
		}

		// Handle Address fields - check if nested or flat
		let address1 = '', address2 = '', address3 = '', zip = '', city = '', state = '', country = '';
		let longitude = null, latitude = null;
		
		if (supervisor.Address && typeof supervisor.Address === 'object') {
			address1 = supervisor.Address.address1 || '';
			address2 = supervisor.Address.address2 || '';
			address3 = supervisor.Address.address3 || '';
			zip = supervisor.Address.zip || '';
			city = supervisor.Address.city || '';
			state = supervisor.Address.state || '';
			country = supervisor.Address.country || '';
			
				// Handle location coordinates
			// if (supervisor.Address.location && supervisor.Address.location.coordinates && supervisor.Address.location.coordinates.length >= 2) {
			// 	longitude = supervisor.Address.location.coordinates[0] || 0;
			// 	latitude = supervisor.Address.location.coordinates[1] || 0;
			// } else {
			// 	longitude = supervisor.longitude || 0;
			// 	latitude = supervisor.latitude || 0;
			// }
		} else {
			address1 = supervisor.address1 || '';
			address2 = supervisor.address2 || '';
			address3 = supervisor.address3 || '';
			zip = supervisor.zip || '';
			city = supervisor.city || '';
			state = supervisor.state || '';
			country = supervisor.country || '';
			// longitude = supervisor.longitude || 0;
			// latitude = supervisor.latitude || 0;
		} 
		
		// Handle phones fields - check if nested or flat
		let phone = '', mobile = '', skype = '';
		if (supervisor.phones && typeof supervisor.phones === 'object') {
			phone = supervisor.phones.phone || '';
			mobile = supervisor.phones.mobile || '';
			skype = supervisor.phones.skype || '';
		} else {
			phone = supervisor.phone || '';
			mobile = supervisor.mobile || '';
			skype = supervisor.skype || '';
		}

		// Handle date of birth
		let dateBirth = new Date();
		if (supervisor.dateBirth) {
			dateBirth = new Date(supervisor.dateBirth);
		}

		const mapped = {
			_id: supervisorRecord._id,
			username: supervisor.username || '',
			password: '', // Don't populate password for security
			email: supervisor.email || '',
			firstName: firstName,
			lastName: lastName,
			initials: initials,
			gender: supervisor.gender || '',
			dateBirth: dateBirth,
			prefix: supervisor.prefix || '',
			address1: address1,
			address2: address2,
			address3: address3,
			zip: zip,
			city: city,
			state: state,
			country: country,
		
			// longitude: longitude !== undefined && longitude !== null ? Number(longitude) : null,
			// latitude: latitude !== undefined && latitude !== null ? Number(latitude) : null,   
		
			phone: phone,
			mobile: mobile,
			skype: skype,
			status: supervisorRecord.status || supervisor.status || 'active',
			imageSrc: supervisorRecord.companies?.imageSrc || supervisorRecord.supervisors?.imageSrc || supervisor.imageSrc || supervisorRecord.imageSrc || ''
		};
		
		return mapped;
	}

	isEditing = () => {
		const userId = this.props.params?.id;
		return userId && userId !== "new";
	}

	getPageTitle = () => {
		return this.isEditing() ? "Edit Supervisor" : "Add Supervisor";
	}


	render() {

		const { data, errors } = this.state;
		return (
			<React.Fragment>
				<ToastContainer 
					position="top-right"
					autoClose={5000}
					hideProgressBar={false}
					newestOnTop={false}
					closeOnClick
					rtl={false}
					pauseOnFocusLoss
					draggable
					pauseOnHover
				/>
				<div>
					<ol className="breadcrumb float-xl-right">
						<li className="breadcrumb-item"><Link to="/user/supervisors">Supervisors</Link></li>
						<li className="breadcrumb-item active">{this.getPageTitle()}</li>
					</ol>
					<h1 className="page-header">
						{this.getPageTitle()} <small>Supervisor-registration-form</small>
					</h1>

					<div className="row">
						<div className="col-xl-10">
							<Panel>
								<PanelHeader>{this.getPageTitle()}</PanelHeader>
								<PanelBody className="panel-form">
									<form className="form-horizontal form-bordered" onSubmit={this.handleSubmit} >

										{errors.submit && (
											<div className="alert alert-danger">
												<strong>Error:</strong> {errors.submit}
											</div>
										)}
 
										<div className="form-group row">
											<label className="col-lg-4 col-form-label" htmlFor="prefix" >Prefix</label>
											<div className="col-lg-8">
												<select name="prefix" id="prefix" value={data.prefix} onChange={this.handleChange} className="form-control" >
													<option value="">Select Prefix</option>
													{this.prefixoptions}
												</select>
											</div>
											{errors.prefix && (<div className="alert alert-danger">{errors.prefix}</div>)}
										</div>

										{this.renderInput("firstName","First Name","text","* Enter Firstname")}
										{this.renderInput("initials","Initials","text","Enter Initials")}
										{this.renderInput("lastName","Last Name","text","* Enter Lastname")}
										
                                        {this.renderInput("address1","Address 1","text","Enter address1")} 
										{this.renderInput("address2","Address 2","text","Enter address2")} 
										{this.renderInput("address3","Address 3","text","Enter address3")}
										{this.renderInput("city","City","text","Enter City")}
										{this.renderInput("state","State","text","Enter State")}
										{this.renderInput("zip","Zip code","text","Enter zipcode")} 
										{this.renderSelect("country","Country",	this.state.countries)}
										
										{/* <div className="form-group row">
											<label className="col-lg-4 col-form-label">Location</label>
											<div className="col-lg-8">
												<div className="row">
													<div className="col-md-5">
														{this.renderInput("longitude","Longitude","number","Enter Longitude (e.g., -74.006)")}
													</div>
													<div className="col-md-5">
														{this.renderInput("latitude","Latitude","number","Enter Latitude (e.g., 40.7128)")}
													</div>
													<div className="col-md-2">
														<button 
															type="button" 
															className="btn btn-info btn-sm"
															onClick={this.getCurrentLocation}
															title="Get current location"
														>
															<i className="fa fa-location-arrow"></i>
														</button>
													</div>
												</div>
												{errors.location && (
													<div className="alert alert-warning mt-2">
														<small>{errors.location}</small>
													</div>
												)}
												<small className="form-text text-muted">
													Current: {(data.latitude && data.longitude) ? `${data.latitude.toFixed(6)}, ${data.longitude.toFixed(6)}` : 'Getting location...'}
												</small>
											</div>
										</div>  */}
										
										<div className="form-group row">
											<label className="col-lg-4 col-form-label" htmlFor="gender" >Gender</label>
											<div className="col-lg-8">
												<select name="gender" id="gender" value={data.gender} onChange={this.handleChange} className="form-control" >
													<option value="">Select Gender</option>
													{this.genderoptions}
												</select>
											</div>
											{errors.gender && (<div className="alert alert-danger">{errors.gender}</div>)}
										</div>

										<div className="form-group row">
											<label className="col-lg-4 col-form-label" htmlFor="dateBirth" >Date of Birth</label>
											<div className="col-lg-8">
												<DatePicker
													onChange={this.handleDobChange}
													id={data.dateBirth}
													value={data.dateBirth}
													selected={data.dateBirth}
													inputProps={{ placeholder: "Datepicker" }}
													className="form-control"
												/>
												{errors.dateBirth && <div className="alert alert-danger">{errors.dateBirth}</div>}
											</div>
										</div>
										
										<div className="form-group row">
											<label className="col-lg-4 col-form-label" htmlFor="username">UserName</label>
											<div className="col-lg-8">
												<div className="row row-space-10">
													<input type="text" id="username" name="username" value={data.username}
														className="form-control m-b-5" placeholder="Enter username"
														onChange={this.handleChange}
														autoFocus />
													{errors.username && (
														<div className="alert alert-danger">
															{errors.username}
														</div>
													)}
												</div>
											</div>
										</div>

										{this.renderInput("email", "Email", "email", "Enter email")}
										{this.renderInput("password", "Password", "password", this.isEditing() ? "Leave blank to keep current password" : "Enter Password")}
										
										{this.renderInput("phone","Phone","text","Enter Phone")} 
										{this.renderInput("mobile","Mobile","text","Enter Mobile")} 
										{this.renderInput("skype","Skype","text","Enter Skype")}

										<div className="form-group row">
											<label className="col-lg-4 col-form-label" htmlFor="imageSrc">Avatar</label>
											<div className="col-lg-8">
												<div className="row row-space-10">
													<input type="file" id="imageSrc" name="imageSrc"
														className="form-control-file m-b-5"
														onChange={this.onChangeImgHandler}
														accept="image/*"
													/>
													{this.isEditing() && data.imageSrc && (
														<small className="form-text text-muted">
															Leave empty to keep current avatar
														</small>
													)}
													{errors.imageSrc && (
														<div className="alert alert-danger">
															{errors.imageSrc}
														</div>
													)}
												</div>
											</div>
										</div>

										<div className="form-group row">
											<label className="col-lg-4 col-form-label" htmlFor="status" >Select Status</label>
											<div className="col-lg-8">
												<select name="status" id="status" value={data.status} onChange={this.handleChange} className="form-control" >
													<option value="">Select Status</option>
													{this.statusoptions}
												</select>
											</div>
											{errors.status && (<div className="alert alert-danger">{errors.status}</div>)}
										</div>

										<div className="form-group row">
											<div className="col-lg-8">
												<button	type="submit" disabled={this.validate()} className="btn btn-primary width-65">Submit</button>
											</div>
										</div>
									</form>
								</PanelBody>
							</Panel>
						</div>
					</div>
				</div>
				</React.Fragment>
		);
	}
}

const mapStateToProps = (state) => ({
	currentUser: getCurrentUser(state)
});

const mapDispatchToProps = (dispatch) => ({
	loadCurrentUser: (id) => dispatch(loadCurrentUser(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Supervisor));
